<template>
  <div>
    <div id="banner">
      <div class="slider-pro sp-horizontal" id="example1" style="width: 100%; max-width: 5200px">
        <div class="sp-slides">
        <!--
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15002842221.jpg"
                alt=""
                title="" /></a>
          </div>
          -->
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15011452161.png"
                alt=""
                title=""/></a>
          </div>
        </div>
      </div>
    </div>
    <div id="wrap_c">
      <div class="breadCrumb">
        <router-link :to="{name:'首頁'}" class="breadCrumb_no" title="首頁">首頁</router-link>
        <router-link :to="{name:'網站導覽'}"><span>網站導覽</span></router-link>
      </div>

      <div>
        <!--###內頁中間內容區塊###-->
        <div class="cC">

          <h2 class="titleA">網站導覽</h2>

          <div class="info_content">

            <table width="100%" border="0" align="center" cellpadding="0" cellspacing="2">
              <tr>
                <td width="2%" align="center">
                  <img src="~@/assets/arrow_00.gif" width="4" height="7"
                    alt="*" /></td>

                <td style="padding:2px" width="*%" align="left">
                  <b><router-link :to="{name:'公司簡介'}" title="關於白金">1. 關於白金</router-link></b>
                </td>
              </tr>
              <tr>
                <td width="3%" align="center">&nbsp;</td>
                <td style="padding:2px;padding-left:18px" width="*%" align="left">
                  <router-link :to="{name:'公司簡介'}" title="關於白金">1.1 公司簡介</router-link>
                </td>
              </tr>

              <tr>
                <td width="3%" align="center">&nbsp;</td>
                <td style="padding:2px;padding-left:18px" width="*%" align="left">
                  <router-link :to="{name:'經營理念'}" title="經營理念">1.2 經營理念</router-link>
                </td>
              </tr>

              <tr>
                <td width="3%" align="center">&nbsp;</td>
                <td style="padding:2px;padding-left:18px" width="*%" align="left">
                  <router-link :to="{name:'核心競爭力'}" title="核心競爭力">1.3 核心競爭力</router-link>
                </td>
              </tr>

              <tr>
                <td width="3%" align="center">&nbsp;</td>
                <td style="padding:2px;padding-left:18px" width="*%" align="left">
                  <router-link :to="{name:'企業沿革'}" title="企業沿革">1.4 企業沿革</router-link>
                </td>
              </tr>

              <tr>
                <td width="3%" align="center">&nbsp;</td>
                <td style="padding:2px;padding-left:18px" width="*%" align="left">
                  <router-link :to="{name:'企業社會責任'}" title="企業社會責任">1.5 企業社會責任</router-link>
                </td>
              </tr>

              <tr>
                <td width="3%" align="center">&nbsp;</td>
                <td style="padding:2px;padding-left:18px" width="*%" align="left">
                  <router-link :to="{name:'產業新聞'}" title="產業新聞">1.6 產業新聞</router-link>
                </td>
              </tr>



              <tr>
                <td width="2%" align="center">
                  <img src="~@/assets/arrow_00.gif" width="4" height="7"
                    alt="*" /></td>

                <td width="*%" style="padding:2px" align="left">
                  <b><router-link :to="{name:'產品與服務'}" title="產品與服務">2. 產品與服務</router-link></b>
                </td>
              </tr>
            


              <tr>
                <td width="2%" align="center">
                  <img src="~@/assets/arrow_00.gif" width="4" height="7"
                    alt="*" /></td>

                <td width="*%" style="padding:2px" align="left">
                  <b><router-link :to="{name:'工作環境'}" title="人才招募">3. 人才招募</router-link></b>
                </td>
              </tr>
              <tr>
                <td width="3%" align="center">&nbsp;</td>
                <td style="padding:2px;padding-left:18px" width="*%" align="left">
                  <router-link :to="{name:'工作環境'}" title="幸福白金">3.1 幸福白金</router-link>
                </td>
              </tr>

              <tr>
                <td width="3%" align="center">&nbsp;</td>
                <td style="padding:2px;padding-left:18px" width="*%" align="left">
                  <router-link :to="{name:'加入白金'}" title="加入白金">3.2 加入白金</router-link>
                </td>
              </tr>

              <tr>
                <td width="2%" align="center">
                  <img src="~@/assets/arrow_00.gif" width="4" height="7"
                    alt="*" /></td>

                <td width="*%" style="padding:2px" align="left">
                  <b><router-link :to="{name:'營業據點'}" title="聯絡我們">4. 聯絡我們</router-link></b>
                </td>
              </tr>
              <tr>
                <td width="3%" align="center">&nbsp;</td>
                <td style="padding:2px;padding-left:18px" width="*%" align="left">
                  <router-link :to="{name:'營業據點'}" title="營業據點">4.1 營業據點</router-link>
                </td>
              </tr>

              <tr>
                <td width="3%" align="center">&nbsp;</td>
                <td style="padding:2px;padding-left:18px" width="*%" align="left">
                  <router-link :to="{name:'聯絡方式'}" title="聯絡方式">4.2 聯絡方式</router-link>
                </td>
              </tr>



            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'intro',
  data () {
    return {
      isAboutPage: true
    }
  },
  created: function () {
    console.log('created')
  },
  mounted: function () {
    console.log('moundted')
    this.init()
    this.$emit('setCurrentMenu', 'about'); // about/ product/ recruit/ contactus
  },
  methods: {
    init: function () {
      $('#rwd_nav').pageslide({
          modal: true
      });
      $('.sp-selected .sp-font span').addClass('animated fadeInLeft');
      $('.sp-selected .sp-font2').addClass('animated fadeInRight');
      $('#example1').sliderPro({
          keyboardOnlyOnFocus: true,
          set_swipe: '1',
          width: '5120',
          height: '1280',
          autoplay: true,
          waitForLayers: true,
          autoScaleLayers: false,
          fade: true,
          autoplayDelay: 5000,
          arrows: false,
          buttons: false,
          breakpoints: {
            1024: {
              forceSize: '',
              width: '1024',
              height: '256'
            }
          }
      });
      sliderPro_add_title('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@');
      // initVideo();
    }
  }
}
</script>
<style src='@/assets/css/15347449502.css'>
</style>


// WEBPACK FOOTER //
// src/components/Sitemap.vue